import { FREQUENCY_TYPES } from "../../constants/Constants";
import ValidationMessage from "../../constants/ValidationMessage";
import * as yup from 'yup';


const AddChoresValidation: any = yup.object().shape({
    hh_id: yup.string().required(ValidationMessage.SelectField("a household")),
    cc_id: yup.string().required(ValidationMessage.SelectField("a chore")),
    d_by: yup.string().required(ValidationMessage.SelectField("done by")),
    description: yup
        .string()
        .test(
            "no-more-than-6-consecutive-digits",
            "Please do not enter more than 6 consecutive numbers.",
            (value) => {
                if (!value) return true; // allow empty
                return !/\d{7,}/.test(value); // fail if 6+ digits in a row
            }
        ),
    h_spent: yup
        .string()
        .test(
            'h_spent-required',
            // 
            ValidationMessage.Field("a value greater than 0"),
            function (value: any) {
                const { h_spent } = this.parent;
                if (Number(h_spent) === 0) return false;
                return true;
            }
        ),
    f_value: yup
        .string()
        .nullable()
        .test(
            'frequency-required',
            ValidationMessage.SelectField("an interval."),
            function (value: any) {
                const { f_type } = this.parent;
                if (f_type != FREQUENCY_TYPES?.ONCE_ONLY) {
                    return !!value
                }
                return true;
            }
        ),
    e_date: yup
        .string()
        .test(
            'e_date-required',
            ValidationMessage.SelectField("an end date"),
            function (value: any) {
                const { f_type } = this.parent;
                if (f_type != FREQUENCY_TYPES?.ONCE_ONLY) {
                    return !!value
                }
                return true;
            }
        ),

    s_date: yup
        .string()
        .test(
            's_date-required',
            function (value: any) {
                const { f_type } = this.parent;
                let message;
                if (f_type == FREQUENCY_TYPES?.ONCE_ONLY) {
                    message = ValidationMessage.SelectField("a date");
                } else {
                    message = ValidationMessage.SelectField("a start date");
                }
                return !!value || this.createError({ message });
            }
        ),

    s_days_or_months: yup
        .array()
        .test(
            's_days_or_months-required',
            function (value: any) {
                const { f_type, s_days_or_months } = this.parent;
                let message;
                if (f_type == FREQUENCY_TYPES?.WEEKLY && (!s_days_or_months || s_days_or_months.length === 0)) {
                    message = ValidationMessage.SelectField("at least one day");
                } else if (f_type == FREQUENCY_TYPES?.MONTHLY && (!s_days_or_months || s_days_or_months.length === 0)) {
                    message = ValidationMessage.SelectField("at least one month");
                }
                if (message) { return this.createError({ message }); }
                return true;
            }
        ),
});

export default AddChoresValidation